import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'cream' | 'black' | 'gold-light';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const backgrounds = {
    white: 'bg-white',
    cream: 'bg-[#FAFAF9]',
    black: 'bg-black text-white',
    'gold-light': 'bg-[#FAFAF9]'
  };
  return <section id={id} className={`py-16 md:py-24 ${backgrounds[background]} ${className}`} data-id="element-302">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-303">{children}</div>
    </section>;
}